import { render, staticRenderFns } from "./portApproveList.vue?vue&type=template&id=c963c62c&scoped=true&"
import script from "./portApproveList.vue?vue&type=script&lang=js&"
export * from "./portApproveList.vue?vue&type=script&lang=js&"
import style0 from "./portApproveList.vue?vue&type=style&index=0&id=c963c62c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c963c62c",
  null
  
)

export default component.exports